/**
 * Agrega progresso de cursos a partir de uma lista de colaboradores.
 */

function enrolmentsOf(user) {
    if (Array.isArray(user?.enrolments) && user.enrolments.length) return user.enrolments;
    if (Array.isArray(user?.progress?.enrolments)) return user.progress.enrolments;
    return Array.isArray(user?.enrolments) ? user.enrolments : [];
}

export function averageProgress(users = []) {
    if (!users.length) return 0;
    const sum = users.reduce((acc, u) => acc + (Number(u.progressPercent) || 0), 0);
    return Math.round(sum / users.length);
}

export function totalOverdue(users = []) {
    return users.reduce((acc, u) => {
        if (typeof u.overdueCourses === 'number') return acc + u.overdueCourses;
        return acc + enrolmentsOf(u).filter((e) => e.status === 'overdue').length;
    }, 0);
}

/**
 * Agrupa enrolments por courseId com contagens de status.
 */
export function aggregateCourses(users = []) {
    const map = new Map();

    users.forEach((user) => {
        enrolmentsOf(user).forEach((enrolment) => {
            const id = String(enrolment.courseId || enrolment.courseName || '');
            if (!id) return;
            if (!map.has(id)) {
                map.set(id, {
                    courseId: enrolment.courseId || id,
                    courseName: enrolment.courseName || id,
                    assigned: 0,
                    completed: 0,
                    inProgress: 0,
                    overdue: 0,
                    notStarted: 0,
                    progressSum: 0,
                });
            }
            const row = map.get(id);
            row.assigned += 1;
            row.progressSum += Number(enrolment.progress) || 0;
            if (enrolment.status === 'completed') row.completed += 1;
            else if (enrolment.status === 'overdue') row.overdue += 1;
            else if (enrolment.status === 'in_progress') row.inProgress += 1;
            else row.notStarted += 1;
        });
    });

    return [...map.values()]
        .map((row) => ({
            ...row,
            completionRate: row.assigned
                ? Math.round((row.completed / row.assigned) * 100)
                : 0,
            avgProgress: row.assigned ? Math.round(row.progressSum / row.assigned) : 0,
        }))
        .sort((a, b) => a.courseName.localeCompare(b.courseName, 'pt-BR'));
}

export function mergeCourseCatalog(courseRows, catalog = []) {
    const byId = new Map(courseRows.map((c) => [String(c.courseId), c]));
    catalog.forEach((item) => {
        const id = String(item.courseId || item.id || '');
        if (!id || byId.has(id)) return;
        byId.set(id, {
            courseId: id,
            courseName: item.courseName || item.name || id,
            assigned: 0,
            completed: 0,
            inProgress: 0,
            overdue: 0,
            notStarted: 0,
            completionRate: 0,
            avgProgress: 0,
        });
    });
    return [...byId.values()].sort((a, b) =>
        a.courseName.localeCompare(b.courseName, 'pt-BR')
    );
}

export default {
    averageProgress,
    totalOverdue,
    aggregateCourses,
    mergeCourseCatalog,
};
